import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../core/services/auth/auth.service';
import { UtilityService } from '../../core/services/utility/utility.service';
import { UserProfileService } from '../user-profile/user-profile.service';

// import services object here...
import { SpinnerService } from '../../core/services/spinner/spinner.service';
import { BodyPaintManualService } from './body-paint-manual.service';

// import all Model objects or interfaces Goes here...
import { SubscriptionLike as ISubscription } from 'rxjs';
import { HandleError } from '../../core/models/handle-error';

import { APP_SETTINGS } from '@services';
import { AnalyticsService } from '../../core/services/analytics/analytics.service';
import { PagerService } from '../pagination/pager.service';
import { NgIf, NgClass, NgStyle, NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { SearchFilterPipe } from '../../shared/pipes/search-filter.pipe';
import { SortByFilterPipe } from '../../shared/pipes/sort-by-filter.pipe';

@Component({
    selector: 'app-body-and-paint-manual',
    templateUrl: './body-and-paint-manual.component.html',
    styleUrls: ['./body-and-paint-manual.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        NgClass,
        NgStyle,
        FormsModule,
        NgFor,
        NgxPaginationModule,
        SearchFilterPipe,
        SortByFilterPipe,
    ],
})
export class BodyAndPaintManualComponent implements OnInit, OnDestroy {

  public allBodyPaintManuals: string[] = [];
  public newBodyPaintManuals: string[] = [];
  public recentBodyPaintManuals: string[] = [];

  public bodyPaintError = new HandleError();
  public search4Manual;
  APP_SETTINGS: any;
  private subsciptions: ISubscription[];

  // sorting asc/desc initialization
  records: Array<any>;
  isDesc = false;
  column = '';
  direction: number;

  screenWidth: number;

  // top control panel flags set to default
  showAllFlag = false;
  showNewFlag = false;
  showRecentFlag = false;
  totalNewCount = 0;
  public p;
  errorMessage: string;
  private userName: string;

  constructor(
    private spinnerService: SpinnerService,
    private bodyPaintManualService: BodyPaintManualService,
    private changeDetector: ChangeDetectorRef,
    private utilityService: UtilityService,
    private userProfileService: UserProfileService,
    private authService: AuthService,
    private analyticsService: AnalyticsService,
    private pagerService: PagerService) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    // this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
    //   this.userName = userData['email'];
    // });
    this.userName = this.authService.getUserName();
    this.subsciptions = [];
    this.APP_SETTINGS = APP_SETTINGS;
    APP_SETTINGS.currentPage = 'body-paint';
    // this.initialLoadAllBodyPaintManuals();

    if (APP_SETTINGS.bodyPaintManual == 'all') {
      this.showAllFlag = true;
      this.showAll();
    }
    if (APP_SETTINGS.bodyPaintManual == 'new') {
      this.showNewFlag = true;
      this.showNew();
    }
    if (APP_SETTINGS.bodyPaintManual == 'history') {
      this.showRecent();
    }

  }

  initialLoadNewBodyPaintManuals() {
    this.showNewFlag = true;
    this.showNew();
  }

  initialLoadAllBodyPaintManuals() {
    this.showAllFlag = true;
    this.showAll();
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  showAll() {
    // set the ALL active tab showing with BMW blue color
    this.showAllFlag = true;
    this.showNewFlag = false;
    this.showRecentFlag = false;
    this.errorMessage = '';
    APP_SETTINGS.bodyPaintManual = 'all';
    // if (this.allBodyPaintManuals.length === 0) {

    // set the spinner to show and alter hide below
    this.spinnerService.show('bmwSpinner');
    // reset the error message from HandleError class
    HandleError.resetErrorMessage();

    // Eager load All body paint manuals
    this.bodyPaintManualService.getAllBodyPaintManuals()
      .subscribe(data => {
        this.allBodyPaintManuals = data.content;
        this.totalNewCount = data.newSize;
        this.bodyPaintError.bmwAppError().flag = false;
        // array copy all
        // this.pagerService.allItems = this.allBodyPaintManuals.map(item => Object.assign({}, item));
        // this.pagerService.setPage(1);
        // this.showingAll();

        this.changeDetector.detectChanges();
        this.spinnerService.hide('bmwSpinner');
      }, (error) => {
        this.spinnerService.hide('bmwSpinner');
        HandleError.handleAPIError(error);
      }
      );
    // } else {
    //   this.showingAll();
    //   return;
    // }
  }

  showingAll() {
    this.pagerService.allItems = this.allBodyPaintManuals.map(item => Object.assign({}, item));
    // reset the pager object
    this.pagerService.pager = {};
    this.pagerService.setPage(1);

    // reset error message to not show
    this.bodyPaintError.bmwAppError().flag = false;
  }

  showNew() {
    // set the NEW active tab showing with BMW blue color
    this.showNewFlag = true;
    this.showAllFlag = false;
    this.showRecentFlag = false;
    this.errorMessage = '';
    APP_SETTINGS.bodyPaintManual = 'new';
    // if (this.newBodyPaintManuals.length === 0) {

    // set the spinner to show and alter hide below
    this.spinnerService.show('bmwSpinner');
    // reset the error message from HandleError class
    HandleError.resetErrorMessage();

    // Eager load New technical training manuals
    this.bodyPaintManualService.getNewBodyPaintManuals()
      .subscribe(data => {
        this.allBodyPaintManuals = data;
        this.totalNewCount = this.allBodyPaintManuals.length;
        if (this.totalNewCount === 0) {
          this.errorMessage = 'No New Records Found';
        }
        this.bodyPaintError.bmwAppError().flag = false;
        // this.showingNew();

        this.changeDetector.detectChanges();
        this.spinnerService.hide('bmwSpinner');
      }, (error) => {
        this.spinnerService.hide('bmwSpinner');
        HandleError.handleAPIError(error);
      }
      );
    // } else {
    //   this.showingNew();
    //   return;
    // }
  }

  showingNew() {
    this.pagerService.allItems = this.newBodyPaintManuals.map(item => Object.assign({}, item));
    // reset the pager object 
    this.pagerService.pager = {};
    this.pagerService.setPage(1);

    // reset error message to not show
    this.bodyPaintError.bmwAppError().flag = false;

  }

  showRecent() {
    // set the RECENT active tab showing with BMW blue color
    this.showRecentFlag = true;
    this.showNewFlag = false;
    this.showAllFlag = false;
    this.errorMessage = '';
    APP_SETTINGS.bodyPaintManual = 'history';
    // if (this.recentBodyPaintManuals.length === 0) {

    // set the spinner to show and alter hide below
    this.spinnerService.show('bmwSpinner');
    // reset the error message from HandleError class
    HandleError.resetErrorMessage();

    // Eager load Recent Body And Paint Manuals
    this.bodyPaintManualService.getRecentBodyPaintManuals(this.userName)
      .subscribe(data => {
        this.allBodyPaintManuals = data;
        if (this.allBodyPaintManuals.length === 0) {
          this.errorMessage = 'No History Found';
        }
        this.bodyPaintError.bmwAppError().flag = false;
        this.showingRecent();

        this.changeDetector.detectChanges();
        this.spinnerService.hide('bmwSpinner');
      }, (error) => {
        this.spinnerService.hide('bmwSpinner');
        HandleError.handleAPIError(error);
      }
      );
    // } else {
    //   return;
    // }
  }

  showingRecent() {
    this.pagerService.allItems = this.recentBodyPaintManuals.map(item => Object.assign({}, item));
    this.changeDetector.detectChanges();
    // reset the pager object 
    this.pagerService.pager = {};
    this.pagerService.setPage(1);

    // reset error message to not show
    this.bodyPaintError.bmwAppError().flag = false;

  }

  sortBy(propertyParam) {
    this.isDesc = !this.isDesc; // change the direction
    this.column = propertyParam;
    this.direction = this.isDesc ? 1 : -1;
  }

  addManualToHistory(isSaved, manualId, documentNumber) {
    if (!isSaved) {
      this.subsciptions.push(this.bodyPaintManualService.addManualToUserHistory(this.userName, manualId).subscribe());
      //Analytics Call
      if (APP_SETTINGS.isAdmin === 'true') {
        this.analyticsService.trackClicksbyAdminUser('Body & Paint Manuals', documentNumber, this.userName);
      }
      else {
        this.analyticsService.trackClicksByDocumentsContentTypeLineMake('Body & Paint Manuals', documentNumber);
      }
      if (APP_SETTINGS.isExternal === 'true') {
        this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
          this.analyticsService.trackClicksByExternalContentType('Body & Paint Manuals', documentNumber, userData['address1'], userData['city'], userData['state'], userData['zipCode']);
        });
      }
      if (APP_SETTINGS.isDealer === 'true') {
        this.analyticsService.trackDealerContentTypeLocation('Body & Paint Manuals', documentNumber, APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode,
          APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription)
      }
    }
  }

  ngOnDestroy(): void {
    this.subsciptions.map(sub => sub.unsubscribe());
  }

  pageNumChange(event) {    
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
  }

}
